import { gql } from 'graphql-request';
import { sectionHighlighBannerContentGql } from '../visual-blocks/sectionHighlightBanner';

export const campaignCacheKey = 'mm_campaign_cache';

export const campaignQuery = ({ filters }: { filters: string }): string => gql`
  campaign(
    filter: ${filters}
    orderBy: [campaignId_DESC]
  ) {
    active: campaignActive
    name: campaignName
    startDate: campaignStartDate
    endDate: campaignEndDate
    seo {
      description
      title
      image {
        url
      }
    }
    highlightBanner {
      ${sectionHighlighBannerContentGql}
    }
  }`;

export const getCampaignVariablesAndFilters = (
  filterByCampaign: boolean,
  isTaxonomy?: boolean
): { variablesDefinition: string; filters: string } => {
  let variablesDefinition = '$now: DateTime';
  let filters = `{ 
    campaignActive: { eq: true } 
    campaignStartDate: { lte: $now } 
    campaignEndDate: { gte: $now }
    channel: { neq: "app" }
  }`;

  if (filterByCampaign) {
    variablesDefinition = '$campaignId: IntType';
    filters = `{
      campaignId: { eq: $campaignId }
    }`;
  }

  if (isTaxonomy) {
    variablesDefinition = `${variablesDefinition} $taxonomyUrl: String, $device: String`;
  }

  return { variablesDefinition, filters };
};
export type CampaignType = NonNullable<any>;

export type GetCampaignResult<
  T extends { campaign: any } = {
    campaign: CampaignType;
  },
> = T;
